import React from "react";

import { Flex, Text } from "@chakra-ui/react";

const CardCategoria = ({ categoria, setCategoriaId, setCategoria }) => {
  return (
    <Flex
      bgColor="#E3E3E3"
      borderRadius="7px"
      p="12px"
      h="80px"
      cursor={"pointer"}
      onClick={() => {
        setCategoria(categoria);
        setCategoriaId(categoria[0]);
      }}
    >
      <Flex
        bgColor="#169499"
        justifyContent="center"
        alignItems="center"
        borderRadius="23px"
        p="10px"
        w="70%"
        flex={6}
      >
        <Text
          color="#FFFFFF"
          fontWeight="400"
          fontSize={{ base: "16px", sm: "20px", lg: "18px", xl: "20px" }}
          lineHeight="20px"
          textAlign="center"
        >
          {categoria[1]}
        </Text>
      </Flex>
      <Flex justifyContent="center" alignItems="center" flex="1">
        <Text
          color="#797A80"
          fontWeight="400"
          fontSize="30px"
          lineHeight="15px"
        >
          {categoria[2].length}
        </Text>
      </Flex>
    </Flex>
  );
};

export default CardCategoria;
